import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { type ViewMode } from '../enums/view-mode';
import { configFixture } from '../fixtures/config.fixture';
import { type Config } from '../interfaces/config';

@Injectable({
    providedIn: 'root',
})
export class ChatService {
    private readonly configuration: BehaviorSubject<Config> = new BehaviorSubject<Config>(configFixture);

    public getConfig(): BehaviorSubject<Config> {
        return this.configuration;
    }

    public setConfig(config: Config): void {
        this.configuration.next(config);
    }

    public currentConfig(): Config {
        return this.configuration.getValue();
    }

    public setVisibility(value: boolean): void {
        const current: Config = this.currentConfig();
        current.panel.visible = value;

        this.configuration.next(current);
    }

    public toggleVisibility(): void {
        this.setVisibility(this.currentConfig().panel.visible === false);
    }

    public setMinimized(value: boolean): void {
        const current: Config = this.currentConfig();
        current.panel.minimized = value;

        this.configuration.next(current);
    }

    public toggleMinimized(): void {
        this.setMinimized(this.currentConfig().panel.minimized === false);
    }

    public setViewMode(value: ViewMode): void {
        const current: Config = this.currentConfig();
        current.panel.viewMode = value;

        this.configuration.next(current);
    }

    public toggleUserNote(): void {
        const current: Config = this.currentConfig();
        current.bot.showUserNote = !current.bot.showUserNote;

        this.configuration.next(current);
    }
}
